// Translated testimonials data
export const getTestimonialsData = (language = 'fr') => {
  const testimonials = {
    fr: [
      {
        id: 1,
        name: "Marie Dubois",
        location: "Avignon",
        rating: 5,
        text: "Travail exceptionnel ! Notre terrasse en béton imprimé est magnifique. L'équipe est professionnelle et très à l'écoute.",
        date: "Janvier 2024",
        project: "Terrasse 120m²"
      },
      {
        id: 2,
        name: "Jean-Pierre Martin",
        location: "Orange",
        rating: 5,
        text: "Prestation impeccable du début à la fin. Le béton désactivé correspond exactement à nos attentes. Je recommande vivement !",
        date: "Décembre 2023",
        project: "Allée de jardin"
      },
      {
        id: 3,
        name: "Sophie Laurent",
        location: "Carpentras",
        rating: 5,
        text: "Très satisfaits du résultat ! La plage de piscine est superbe et résistante. Un grand merci pour le conseil et la qualité.",
        date: "Février 2024",
        project: "Plage de piscine"
      },
      {
        id: 4,
        name: "Patrick Bernard",
        location: "Châteauneuf-du-Pape",
        rating: 5,
        text: "Entreprise sérieuse et compétente. Le béton bâlé de notre cour est parfait. Délais respectés et prix correct.",
        date: "Novembre 2023",
        project: "Cour 150m²"
      }
    ],
    en: [
      {
        id: 1,
        name: "Marie Dubois",
        location: "Avignon",
        rating: 5,
        text: "Exceptional work! Our stamped concrete terrace is magnificent. The team is professional and very attentive.",
        date: "January 2024",
        project: "120m² Terrace"
      },
      {
        id: 2,
        name: "Jean-Pierre Martin",
        location: "Orange",
        rating: 5,
        text: "Impeccable service from start to finish. The exposed aggregate concrete matches our expectations exactly. Highly recommended!",
        date: "December 2023",
        project: "Garden Path"
      },
      {
        id: 3,
        name: "Sophie Laurent",
        location: "Carpentras",
        rating: 5,
        text: "Very satisfied with the result! The pool deck is superb and durable. Many thanks for the advice and quality.",
        date: "February 2024",
        project: "Pool Deck"
      },
      {
        id: 4,
        name: "Patrick Bernard",
        location: "Châteauneuf-du-Pape",
        rating: 5,
        text: "Serious and competent company. The brushed concrete in our courtyard is perfect. Deadlines respected and fair price.",
        date: "November 2023",
        project: "150m² Courtyard"
      }
    ]
  };

  return testimonials[language] || testimonials.fr;
};
